import { __decorate, __metadata } from "tslib";
import { CacheActivePromise } from '@1inch-community/core/decorators';
import { lazyAppContext } from '@1inch-community/core/lazy';
import { OneInchDevPortalCrossChainOnChainAdapter } from '../onchain';
import { PublicProxyClient } from './public-proxy-client';
export class OneInchDevPortalCrossChainPublicProxyAdapter {
    constructor() {
        this.context = lazyAppContext('OneInchDevPortalCrossChainPublicProxyAdapter');
        this.client = new PublicProxyClient();
        this.fallBackAdapter = new OneInchDevPortalCrossChainOnChainAdapter();
    }
    async init(context) {
        this.context.set(context);
        await Promise.all([this.client.init(context), this.fallBackAdapter.init(context)]);
    }
    async getBalances(chainIds, walletAddresses) {
        const pending = [];
        for (const chainId of chainIds) {
            for (const walletAddress of walletAddresses) {
                pending.push(this.client
                    .get(`/balance/v1.2/${chainId}/balances/${walletAddress}`)
                    .then((response) => {
                    return {
                        id: [chainId, walletAddress].join(':'),
                        result: response,
                        error: null,
                    };
                })
                    .catch((error) => {
                    return {
                        id: [chainId, walletAddress].join(':'),
                        result: null,
                        error: {
                            code: 0,
                            message: error.message,
                        },
                    };
                }));
            }
        }
        return await Promise.all(pending);
    }
    async getTokenList() {
        const walletIsConnected = await this.walletIsConnected();
        if (!walletIsConnected) {
            return await this.fallBackAdapter.getTokenList();
        }
        try {
            return this.client.get('/token/v1.2/multi-chain');
        }
        catch {
            return await this.fallBackAdapter.getTokenList();
        }
    }
    async getTokenPrice(chainIds) {
        return Promise.all(chainIds.map(async (chainId) => {
            const result = await this.client.get(`/price/v1.1/${chainId}?currency=USD`);
            return {
                id: chainId.toString(),
                result,
                error: null,
            };
        }));
    }
    getGasPrice() {
        throw new Error('Method not implemented.');
    }
    getProxyClient() {
        return this.client;
    }
    walletIsConnected() {
        return this.context.value.wallet.data.isConnected();
    }
}
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Array]),
    __metadata("design:returntype", Promise)
], OneInchDevPortalCrossChainPublicProxyAdapter.prototype, "getBalances", null);
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], OneInchDevPortalCrossChainPublicProxyAdapter.prototype, "getTokenList", null);
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Promise)
], OneInchDevPortalCrossChainPublicProxyAdapter.prototype, "getTokenPrice", null);
//# sourceMappingURL=one-inch-dev-portal-cross-chain-public-proxy.adapter.js.map